module.exports = __webpack_public_path__ + "static/media/omaira2.7f6f29f8.jpeg";